export const priorities = ["low", "normal", "high"];
export const sizes = ["sm", "md", "lg"];
export const variants = ["light", "dark"];
